import { useQuery } from 'react-query';
import ApplicantFormService from '../../../../services/applicantFormService';
import type { ApplicantFormData } from '../../types/api';

export type useApplicantFormDataParams = {
  applicantId: string,
  organizationId: string,
  propertyId: string,
};

export type useApplicantFormData = {
  applicantFormData: ApplicantFormData | undefined,
  isLoading: boolean,
};

export default function useApplicantPrimaryFormInformation({
  applicantId,
  organizationId,
  propertyId,
}: useApplicantFormDataParams): useApplicantFormData {
  const queryKey = [
    'applicant-form-data',
    organizationId,
    propertyId,
    applicantId,
  ];

  const applicantFormService = new ApplicantFormService();

  const { data, isLoading } = useQuery(
    queryKey,
    () => {
      return applicantFormService.getApplicantFormData(
        applicantId,
        organizationId,
        propertyId,
      );
    },
    { refetchOnWindowFocus: false },
  );

  return { applicantFormData: data, isLoading };
}
